
export default {
  name: 'BaseProfileProductHeader',
  props: {
    stream: {
      type: Object,
      required: true,
    },
  },
  computed: {
    isAdmin() {
      return !!this.$auth?.user?.roles?.some((role) =>
        ['ADMIN', 'MODERATOR'].includes(role)
      )
    },
    auditorium() {
      if (this.stream?.statistics?.viewsCount < 100) {
        return 'менее 100'
      } else {
        return this.stream?.statistics?.viewsCount
      }
    },
  },
  methods: {
    changeStreamCover(cover) {
      this.$emit('change-stream-cover', cover)
    },
    updateStreamAvatar(avatar) {
      this.$emit('change-product-avatar', avatar)
    },
  },
}
